import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cx } from '@/utils/cx';
import styles from '@/styles/components/Button/style.scss';

export type ButtonVariant = 'primary' | 'go' | 'success' | 'secondary' | 'ghost' | 'outline' | 'warning' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Leading icon. */
  icon?: ReactNode;
  /** Square/round button sized to its icon (children still render, e.g. a badge). Requires aria-label. */
  iconOnly?: boolean;
  round?: boolean;
  fullWidth?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'secondary', size = 'md', icon, iconOnly, round, fullWidth, className, children, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      className={cx(
        styles.button,
        styles[variant],
        styles[size],
        iconOnly && styles.iconOnly,
        round && styles.round,
        fullWidth && styles.fullWidth,
        className,
      )}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
});
